import {
  PersonProfileService,
  InternalPersonProfileService,
} from '@openeducation/oe-rn-services';

import { usePersonProfileNoService } from './use-person-profile-no-service';

export interface TeacherProps {
  personId: number | undefined;
  internal?: boolean;
}

export const usePersonProfile = ({ personId, internal }: TeacherProps) => {
  const {
    personProfile,
    isLoadingPersonProfile,
    isErrorPersonProfile,
    errorPersonProfile,
  } = usePersonProfileNoService({
    personId,
    getProfileById: internal
      ? InternalPersonProfileService.getProfileById
      : PersonProfileService.getProfileById,
  });

  return {
    personProfile,
    isLoadingPersonProfile,
    isErrorPersonProfile,
    errorPersonProfile,
  };
};
